export default "__VITE_ASSET__GgoT2z8j__"